import { Location } from '@angular/common'
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Router, UrlTree } from '@angular/router'

@Component({
  selector: 'lib-back-button',
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  private readonly location = inject(Location)
  private readonly router = inject(Router)

  readonly routerLink = input<string | UrlTree>()

  back() {
    const routerLink = this.routerLink()
    if (routerLink) {
      this.router.navigateByUrl(routerLink)
    } else {
      this.location.back()
    }
  }
}
